const pageURLParameter = window.location.pathname;
const pathnameParameter = pageURLParameter.split(['/']);

// FUNCTION TO CONTROL HEADER/FOOTER FIXED
export function showPartialsFixed(partial, partialShow, partialHide) {
  const partialSelected = document.querySelectorAll(partial);
  const parameters = ['consorcio', 'seguros', 'seminovos', 'contato', 'nossas-lojas', 'blog'];

  partialSelected.forEach((partial) => {

    if (window.innerWidth >= 992) {
      if (parameters.includes(pathnameParameter[1]) && !pathnameParameter[2]) {

        if (window.scrollY > 120) {
          partial.classList.add(partialShow);
          partial.classList.remove(partialHide);

        } else {
          if (partial.classList.contains(partialShow)) {
            partial.classList.add(partialHide);
            partial.classList.remove(partialShow);
          }
        }

      } else {

        if (window.scrollY > 700) {
          partial.classList.add(partialShow);
          partial.classList.remove(partialHide);
        } else {
          if (partial.classList.contains(partialShow)) {
            partial.classList.add(partialHide);
            partial.classList.remove(partialShow);
          }
        }
      }

    } else {

      if (window.scrollY > 600) {
        partial.classList.add(partialShow);
        partial.classList.remove(partialHide);

      } else {

        if (partial.classList.contains(partialShow)) {
          partial.classList.add(partialHide);
          partial.classList.remove(partialShow);
        }
      }
    }
  });
}
